import CardConfiguration, {
  DefaultDateRangeConfiguration,
} from "@app/types/dashboard/CardConfiguration";
import BasePreferences from "@app/types/dashboard/cards/BasePreferences";

export enum MileageTrackingAggregationType {
  SUM = "SUM",
  AVG = "AVG",
}

export interface MileageTrackingCriteria {
  aggregationType: MileageTrackingAggregationType;
}

export default interface MileageTrackingCardConfiguration
  extends CardConfiguration<
    MileageTrackingCriteria,
    DefaultDateRangeConfiguration,
    BasePreferences
  > {}
